module.exports = __webpack_public_path__ + "img/sky-top.79161744.png";